/**
 * Cross-portal appearance handoff (host app → this app).
 * Query names are part of the wire contract; keep in sync with the host portal `appearanceQueryConstants`.
 */
export const PORTAL_APPEARANCE_THEME_QUERY = 'portalTheme';
export const PORTAL_APPEARANCE_ACCENT_QUERY = 'portalAccent';

/** Dispatched after postMessage storage transfer maps Healthcare Portal accent into FEP storage. */
export const PORTAL_APPEARANCE_FROM_OPENER_EVENT = 'portal-appearance-from-opener';
